(() => {
  'use strict';

  const config = document.currentScript?.dataset;
  if (!config?.shop || !config.runtime || document.querySelector('script[src*="/algo_translation_3.js"]')) return;

  // Keep EZ's published runtime and live translation data; only gate its startup.
  const attributes = ['src', 'srcset', 'data-src', 'data-srcset', 'poster'];
  const selector = 'img, source, video';
  const fileName = value => {
    try {
      const name = new URL(value, document.baseURI).pathname.split('/').pop();
      return decodeURIComponent(name).replace(/_(small|medium|large|grande|compact|master|pico|icon|thumb|[0-9]+x(?:[0-9]+)?|x[0-9]+)(?=\.)/i, '');
    } catch (_) {
      return '';
    }
  };
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 8000);

  fetch(`https://translate.freshify.click/storage/json_files/${config.shop}_translations.json`, {
    signal: controller.signal,
    cache: 'no-cache'
  }).then(response => {
    if (!response.ok) throw new Error(`Image translations: HTTP ${response.status}`);
    return response.json();
  }).then(data => {
    const locale = String(window.Shopify?.locale || document.documentElement.lang || 'fr');
    const normalized = locale.toLowerCase();
    const translations = data[locale] || data[normalized] || data[normalized.split('-')[0]] || data.fr || {};
    const names = new Set(Object.entries(translations)
      .filter(([, entry]) => typeof entry === 'string' ? entry : entry?.url)
      .flatMap(([key]) => [key, fileName(key)]));
    if (!names.size) return;

    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      observer.disconnect();
      window.SHOP_NAME = config.shop;
      window.TRANSLATIONS_DATA = data;
      const runtime = document.createElement('script');
      runtime.src = config.runtime;
      runtime.async = true;
      document.head.appendChild(runtime);
    };
    const matches = element => attributes.some(attribute => {
      const value = element.getAttribute(attribute);
      if (!value) return false;
      const urls = attribute.endsWith('srcset') ? value.split(',').map(item => item.trim().split(/\s+/)[0]) : [value];
      return urls.some(url => names.has(url) || names.has(fileName(url)));
    });
    const inspect = root => {
      if (started || !root?.querySelectorAll) return;
      if ((root.matches?.(selector) && matches(root)) || [...root.querySelectorAll(selector)].some(matches)) {
        start();
      }
    };
    // Inspect changed media only, with no polling or repeated full-document scans.
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (started) break;
        if (record.type === 'attributes') {
          if (record.target.matches(selector) && matches(record.target)) start();
        } else {
          record.addedNodes.forEach(inspect);
        }
      }
    });
    observer.observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: attributes
    });
    inspect(document);
  }).catch(error => {
    console.warn('Image translation data could not be loaded:', error);
  }).finally(() => clearTimeout(timeout));
})();
